import { MessageType } from '../../enums/message-type';
import { WebViewMessage } from './web-view-message';

export class CommandMessage extends WebViewMessage {
  public id: string;
  public path: string;
  public arguments: string;
  public result: string;
  public timeoutSec?: number;
  public returnResult: boolean;

  public constructor() {
    super(MessageType.Command);
  }
}
